import { DrillDownMapState, DrillDownMessage, MetaParams } from './types'
import i18n from 'live/services/i18n'
import locale from 'live/init/global-locale'
import { UNINITIALIZED_SPAN } from './components/PointInformation/utils'

const getInitialState = (): DrillDownMapState => ({
    0: { data: [], metaParams: {} }, // layer 0
    1: { data: [], metaParams: {} }, // layer 1
    span: { start: UNINITIALIZED_SPAN, end: UNINITIALIZED_SPAN }
})

export const reducer: WidgetReducerType<DrillDownMapState, DrillDownMessage> = (state = getInitialState(), message) => {
    if (!message) {
        return state
    }

    if (message.baseline && message.type !== 'event') {
        return state
    }

    switch (message.type) {
        case 'start': {
            const init = getInitialState()
            const metaParams = message.events.info as MetaParams
            init[message.layer].metaParams = metaParams

            // // TO-DO It isn't working
            if (locale && metaParams?.locale) {
                i18n.add(metaParams.locale[locale])
            }

            return { ...init }
        }
        case 'event':
            state[message.layer].data = message.events

            return { ...state }

        case 'span':
            if (message.layer === 0) {
                return {
                    ...state,
                    span: { start: message.events.begin, end: message.events.end }
                }
            }

            return state

        default:
            return state
    }
}
